module.exports = __webpack_public_path__ + "media/images/profile/decline-message-c10dd775c4d68d7ca6704c332f70f540.svg";